module.exports = require("lodash/identity");